import { h, Fragment } from "preact";
import { useEffect, useState } from "preact/hooks";

import BasicRecord from "../../../../../foundation/utils/BasicRecord";
import classname from "../../../../../foundation/utils/classname";
import getRedirectUrl from "../../../../../foundation/utils/get-redirect-url";
import { urlResolve } from "../../../../../foundation/utils/url";
import ResponsiveImage from "../../../../../library/ResponsiveImage";
import SignupForm from "../../forms/SignupForm";
import SignupParams from "../../types/SignupParams";
import ContinueWithEmailButton from "../../ContinueWithEmailButton";
import FigmaSSOButton from "../../FigmaSSOButton";
import GoogleSSOButton from "../../GoogleSSOButton";
import LoginSignupTemplate from "../../LoginSignupTemplate";

import styles from "./SignupPage.module.css";

const INITIAL_ANIMATION_DELAY = 3000;
interface Props {
    signupParams: SignupParams;
    signupToken: string;
}

export function SignupPage({ signupParams, signupToken }: Props) {
    const [handle, setHandle] = useState("");
    const [showSignupForm, setShowSignupForm] = useState(!!signupToken || Object.keys(signupParams).length !== 0);
    const [figmaPublishDesignFasterAnimationStarted, setFigmaPublishDesignFasterAnimationStarted] = useState(false);

    const { workspaceName } = signupParams;
    const ssoQuery: BasicRecord = { action: "signup" };
    const redirectToFromSession = signupParams.redirect || sessionStorage.getItem("redirectTo");
    if (redirectToFromSession) {
        ssoQuery["redirect"] = getRedirectUrl(redirectToFromSession, "/");
    }

    function handleContinueWithEmailClick() {
        setShowSignupForm(true);
    }

    useEffect(() => {
        setTimeout(() => {
            setFigmaPublishDesignFasterAnimationStarted(true);
        }, INITIAL_ANIMATION_DELAY);
    }, []);

    // TODO: Fix this after workspace name is correctly encoded in the backend
    const header = workspaceName
        ? <>You're invited to <br/>{workspaceName.replace(/\+/g, " ")}</> : "Welcome to Zeplin!";

    const signupForm = <SignupForm signupParams={signupParams} signupToken={signupToken} onHandleChange={setHandle}/>;
    const continueWithEmail = <ContinueWithEmailButton onClick={handleContinueWithEmailClick}/>;

    return (
        <LoginSignupTemplate
            illustration={<ResponsiveImage asset="img/onboarding-illustration-1.png"/>}
            displayIllustrationOnMobile={false}
            header={header}
            subHeader="We're so happy you're here, let’s start by signing up."
            actionButtons={(
                <>
                    <div class={styles.figmaButtonContainer}>
                        <FigmaSSOButton
                            type="signup"
                            query={ssoQuery}/>
                        <ResponsiveImage
                            class={classname(styles.publishDesignsFasterImg, {
                                [styles.animated]: figmaPublishDesignFasterAnimationStarted
                            })}
                            asset="img/imgPublishDesignsFasterWithFigma.png"/>
                    </div>
                    <GoogleSSOButton
                        type="signup"
                        query={ssoQuery}/>
                </>
            )}
            form={showSignupForm ? signupForm : continueWithEmail}
            footer={<span class={styles.signupPageFooter}>Already have an account? <a href={urlResolve("login", { query: { email: handle } })}>Login</a></span>}/>
    );
}

export default SignupPage;

